'use client'

import { signOut } from 'aws-amplify/auth'
import { useRouter } from 'next/navigation'
import { Button } from '@/src/components'

/**
 * Component for handling user logout
 */
export const LogoutButton = () => {
  const router = useRouter()

  /**
   * Handle user sign out
   */
  const handleSignOut = async () => {
    // Hide Intercom before signing out
    if (typeof window !== 'undefined' && window.Intercom) {
      window.Intercom('shutdown')
    }
    await signOut()
    router.push('/login')
  }

  return (
    <Button
      onClick={handleSignOut}
      type='primary'
      className='hidden md:block'
      size='large'
      text='Logout'
    />
  )
}
